// extracted by mini-css-extract-plugin
module.exports = {"title":"title-2KpJWV5E","list_box":"list_box-3N3yixYY","no_more":"no_more-QkcgwgQF","soft_ad":"soft_ad-1OP2a6Oj","hard_ad":"hard_ad-2O7NgQRk"};